import {
  Grid,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Box,
  FormControl,
  Select,
  MenuItem,
  Stack,
  IconButton,
  Tooltip,
} from "@mui/material";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import React, { useEffect, useRef, useState } from "react";
import { drListWrapper } from "../../style/DoctorListComponent";
import { menuItemStyle, selectField } from "../../style/AppointmentStyle";
import CustomModal from "../CustomModal/CustomModal";
import PrePatientBillPharmacy from "../ModalChildren/PrePatientBillPharmacy";
import { useDispatch } from "react-redux";
import UseFetchDoctorList from "../../helper/UseFetchDoctorList";
import {
  setDoctorOption,
  setPharmacyTableData,
} from "../../redux/slices/pharmacySlice";
import UsePharmacyIndex from "../../helper/UsePharmacyIndex";
import not_found from "../../assets/not_found.svg";
import { useReactToPrint } from "react-to-print";
import PrintPrescription from "../Prescription/printPrescription";
import Cookies from "js-cookie";
import { BASE_URL } from "../../connections/connectionUrl";

const authStaging = Cookies.get("authStaging")
  ? JSON.parse(Cookies.get("authStaging"))
  : null;
const token = authStaging?.token || "";

export const getPatientPrescription = async (id) => {
  const url = `${BASE_URL}/api/v1/prescriptions/${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

const PatientListTable = () => {
  const [patients, setPatients] = useState([]);
  const [patient, setPatient] = useState({});
  const [openBill, setOpenBill] = useState(false);
  const [prescriptionSuccessRes, setPrescriptionSuccessRes] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Prescription",
  });

  const handlePrintPrescription = async (e, prescriptionId, mobile) => {
    e.stopPropagation();
    const data = await getPatientPrescription(prescriptionId);
    setPrescriptionSuccessRes(data);
    setMobileNumber(mobile || "");
    setTimeout(() => {
      handlePrint();
    }, 0);
  };

  const dispatch = useDispatch();
  const { data: drQuery } = UseFetchDoctorList();
  const { data: pharmacyTable, isLoading, refetch } = UsePharmacyIndex();

  dispatch(setPharmacyTableData(pharmacyTable));

  useEffect(() => {
    dispatch(setDoctorOption(drQuery?.doctors));
    setDoctors(drQuery?.doctors);
  }, [drQuery, dispatch]);

  // const { doctorOptions } = useSelector((state) => state.pharmacy);
  const [doctors, setDoctors] = useState(drQuery?.doctors);
  const [doctorId, setDoctorId] = useState(drQuery?.doctors[0]?.id || 1);

  useEffect(() => {
    dispatch(setPharmacyTableData(pharmacyTable));
    // Find the selected doctor and update patients with their appointments
    const selectedDoctor = pharmacyTable?.payload?.doctors?.find(
      (doc) => doc.id === doctorId,
    );
    // console.log(selectedDoctor?.appointments);
    if (selectedDoctor) {
      setPatients(selectedDoctor?.appointments || []); // Update with appointments
    }
  }, [doctorId, pharmacyTable, dispatch]);

  const handleDoctorChange = (event) => {
    setDoctorId(event.target.value);
  };
  // const { data: filterList, refetch, isError } = (doctorId);

  //handle open bill at pharmacy
  const handleOpenBillOpen = (id) => {
    setPatient(id);
    setOpenBill(true);
  };

  const handleOpenBillClose = () => setOpenBill(false);

  return (
    <>
      <Grid
        sx={{
          ...drListWrapper,
          marginX: "auto",
          width: "90%",
          backgroundColor: "neutral.blueShadeBg",
          borderRadius: "50px",
        }}
        container
        justifyContent="center"
        lg={10}
        md={12}
        sm={12}
      >
        {/* Doctor list */}
        <Grid item xs={12}>
          <Box
            display="flex"
            alignItems="center"
            // justifyContent={"space-between"}
            gap={3}
            p={2.2}
            sx={{ backgroundColor: "neutral.blueShadeBg" }}
          >
            <FormControl variant="outlined">
              <Select
                fullWidth
                sx={{
                  ...selectField,
                }}
                value={doctorId || ""}
                onChange={handleDoctorChange}
                name="doctor"
                displayEmpty
              >
                <MenuItem value="" disabled>
                  <span>{"Select Doctor"}</span>
                </MenuItem>
                {doctors?.map((option) => (
                  <MenuItem
                    id={option?.id || "menu"}
                    key={option.id + Math.random()}
                    value={option.id}
                    sx={menuItemStyle}
                  >
                    {option.full_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Stack direction={"row"}>
              <Typography variant="heading2_16" color={"neutral.teal"}>
                Appointments :
              </Typography>
              <Typography
                letterSpacing={"0.15px"}
                variant="heading2_16"
                color={"neutral.teal"}
              >
                {" "}
                {patients?.length}
              </Typography>
            </Stack>
          </Box>

          <TableContainer
            // component={Paper}
            sx={{
              mt: 0,
              maxHeight: "100vh",
              minHeight: "70vh",
              overflowY: "scroll",
              "&::-webkit-scrollbar": {
                display: "none", // Hide the scrollbar for Webkit browsers (Chrome, Safari)
              },
              "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
              "scrollbar-width": "none",
            }}
          >
            <Table
              sx={{
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  display: "none", // Hide the scrollbar for Webkit browsers (Chrome, Safari)
                },
                "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
                "scrollbar-width": "none",
              }}
            >
              <TableHead>
                <TableRow sx={{ width: "100%" }}>
                  <TableCell sx={{ width: "33%", textAlign: "center" }}>
                    <Typography fontSize={"16px"}>Name </Typography>
                  </TableCell>

                  <TableCell sx={{ width: "33%", textAlign: "center" }}>
                    <Typography>Mobile</Typography>
                  </TableCell>

                  <TableCell sx={{ width: "33%", textAlign: "center" }}>
                    <Typography>Patient ID</Typography>
                  </TableCell>
                  <TableCell sx={{ width: "33%", textAlign: "center" }}>
                    <Typography>Prescription</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>

              {patients?.length > 0 ? (
                <TableBody>
                  {patients?.map((patient, index) => (
                    <TableRow
                      key={index}
                      // sx={{ ...tableRowLab, cursor: "pointer" }}
                      sx={{
                        backgroundColor: "white",
                        paddingY: "6px",
                        cursor: "pointer",
                        //  marginBottom: '10px !important', // Force margin with !important
                        borderBottom: "8px solid #EEF6F9",
                        borderTop: index === 0 ? "6px solid #EEF6F9" : "",
                        "&:hover": {
                          transform: "scale(1.001)", // Slight scaling for the pop-up effect
                          // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Subtle shadow for outer glow
                          borderRadius: "20px !important",
                        },
                      }}
                      onClick={() => {
                        handleOpenBillOpen(patient?.prescription_id);
                      }}
                    >
                      <TableCell
                        sx={{
                          padding: "4px",
                          paddingY: "11px",
                          width: "33%",
                          textAlign: "center",
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                        }}
                      >
                        <Typography
                          variant={"heading_light"}
                          color={"CypherMD_Text.black"}
                        >
                          {" "}
                          {patient?.name}
                        </Typography>
                        {/* <Box sx={{ display: "flex", alignItems: "center"  ,width:'max-content'}}>
                          <MobileScreenShareRoundedIcon
                            sx={{ height: "12px", width: "12px" }}
                          />
                          <Typography variant="body2_text">
                            {" "}
                            {patient?.mobile}
                          </Typography>
                        </Box> */}
                      </TableCell>

                      <TableCell
                        sx={{
                          padding: "4px",
                          width: "33%",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant={"heading_light"}>
                          {patient?.mobile}
                        </Typography>
                      </TableCell>

                      <TableCell
                        sx={{
                          padding: "4px",
                          width: "33%",
                          textAlign: "center",
                          // borderTopRightRadius: "20px",
                          // borderBottomRightRadius: "20px",
                        }}
                      >
                        <Typography variant={"heading_light"}>
                          {patient?.uid}
                        </Typography>
                      </TableCell>

                      <TableCell
                        sx={{
                          padding: "4px",
                          width: "33%",
                          textAlign: "center",
                          borderTopRightRadius: "20px",
                          borderBottomRightRadius: "20px",
                        }}
                      >
                        <Tooltip title="Print Prescription">
                          <span>
                            <IconButton
                              onClick={(e) =>
                                handlePrintPrescription(
                                  e,
                                  patient?.prescription_id,
                                  patient?.mobile,
                                )
                              }
                              disabled={!patient?.prescription_id}
                              color="primary"
                            >
                              <PrintOutlinedIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </TableCell>

                      {/* <TableCell sx={{ padding: "4px", pl: "16px" }}>
                        <Typography
                          letterSpacing={"0.15px"}
                          variant="heading2_14"
                          color={"neutral.main"}
                        >
                          {patient?.visit_time}
                        </Typography>{" "}
                        <br />
                        <Typography
                          color={"text.grey"}
                          variant="body3_text"
                          fontWeight={"600"}
                        >
                           {patient?.visit_time} 
                        </Typography>
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              ) : (
                <TableRow sx={{ borderBottom: "2px solid #F7F7FF" }}>
                  <TableCell
                    sx={{
                      textAlign: "center",
                    }}
                    rowSpan={5}
                    colSpan={5}
                  >
                    {/* <Typography color={"black"} variant="heading2">
                      Data Not Found
                    </Typography> */}

                    <Box
                      sx={{
                        width: "40%",
                        margin: "auto",
                        display: patients?.length > 0 ? "none" : "",
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          backgroundColor: "white",
                          borderRadius: "20px",
                          height: "185px",
                          marginTop: "100px",
                        }}
                      >
                        <Box sx={{ marginTop: "-80px", marginLeft: "30px" }}>
                          <img src={not_found} alt="" width={"180px"} />
                        </Box>

                        <Box sx={{ paddingRight: "90px", marginTop: "-14px" }}>
                          <Typography
                            fontSize={"24px"}
                            fontWeight={"bold"}
                            color={"neutral.teal"}
                          >
                            All Done,{" "}
                            <Typography
                              variant="span"
                              color={"black"}
                            ></Typography>{" "}
                          </Typography>
                          {/* <Typography fontSize={'24px'}  fontWeight={'bold'} >You've made it </Typography> */}
                          <Typography sx={{ marginTop: "8px" }}>
                            {" "}
                            Data not found!
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%" }}
        open={openBill}
        onClose={handleOpenBillClose}
      >
        <PrePatientBillPharmacy
          id={patient}
          onClose={handleOpenBillClose}
          refetch={refetch}
        />
      </CustomModal>

      <div style={{ display: "none" }}>
        <PrintPrescription
          ref={printRef}
          prescription={{ ...prescriptionSuccessRes, mobileNumber }}
        />
      </div>
    </>
  );
};

export default PatientListTable;
